import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FinancialReportService } from '../../../../../core/services/financial-report.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  imports: [CommonModule, FormsModule, LoadingComponent, HeaderComponent],
  styleUrls: ['./claim.component.css']
})
export class ClaimComponent {
  loading = false;
  report: any = null;

  filters = { from: '', to: '' };

  constructor(private reportService: FinancialReportService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.reportService.get({ from: this.filters.from || undefined, to: this.filters.to || undefined }).subscribe({
      next: (res: any) => { this.loading = false; this.report = res.data; },
      error: (err: any) => { this.loading = false; AppErrorShow.showError('Rapport financier', err); }
    });
  }

  resetFilters(): void {
    this.filters = { from: '', to: '' };
    this.load();
  }

  print(): void { window.print(); }
}
